<template>
	<div v-once>


		<!--MV-->
		<section class="hero">
			<div class="wrapper hero-deco">
				<img src="/static/renew_img/quickmail/yagitaku_lp_mv_3.png" alt="ヤギの宅配便ヤギ" class="hero-img_LP pc">
				<img src="/static/renew_img/quickmail/yagitaku_lp_mv-sp_3.png" alt="ヤギの宅配便ヤギ" class="hero-img_LP sp">

				<div style="
				text-align: center;
				margin: 0 auto 30px;
			">
					<a href="/yagiprimequickmail/info" style="
				background: #E3165C;
				color: #fff;
				font-size: 1.2rem;
				font-weight: bold;
				display: flex;
				justify-content: center;
				align-items: center;
				padding: 20px;
				border-radius: 40px;
				border-bottom: 5px solid #004D40;
			">購入手続きはこちら　&gt;&gt;</a>
				</div>
				<div class="hero-txt">
					<img src="/static/renew_img/quickmail/yagitaku-txt.png" alt="シンプルに入力だけ" class="sp-hero-txt pyon01">
					<img src="/static/renew_img/quickmail/nedan_20230630.png" alt="1,100円（税込）" class="pc">
					<img src="/static/renew_img/quickmail/nedan_20230630.png" alt="1,100円（税込）"
						class="sp sp-nedan sp-hero-txt">
				</div>
			</div>
			<p class="scroll-announce" style="font-size: 0.8rem; color: #004D40; text-align: center; margin-top: 30px;">
				みんなの履歴書食べないよう気をつけるメェッ！</p>
		</section>

		<div class="border-block">
			<img src="/static/renew_img/quickmail/deco01.png" alt="区切り線" class="border01">
			<img src="/static/renew_img/quickmail/deco01_2.png" alt="区切り線" class="border01 border01-2"
				style="background: #000;">
		</div>

		<!--面倒なシーン-->
		<section class="second">
			<div class="taihen">
				<div class="wrapper">
					<div class="taihen-list pc">
						<img src="/static/renew_img/quickmail/taihen03.png" alt="大変なのたくさん"
							class="taihen-img taihen-img01">
						<img src="/static/renew_img/quickmail/taihen01.png" alt="郵送で企業に送るのめんどくさいメェ〜"
							class="taihen-img02">
						<img src="/static/renew_img/quickmail/taihen04.png" alt="大変なのたくさん"
							class="taihen-img taihen-img03">
					</div>
					<div class="sp">
						<img src="/static/renew_img/quickmail/taihen01.png" alt="郵送で企業に送るのめんどくさいメェ〜"
							class="taihen-img02">
						<div class="taihen-list">
							<img src="/static/renew_img/quickmail/taihen03.png" alt="大変なのたくさん" class="taihen-img">
							<img src="/static/renew_img/quickmail/taihen05.png" alt="大変なのたくさん" class="taihen-img">
						</div>
					</div>
					<img src="/static/renew_img/quickmail/taihen02.png" alt="何回やるんだ〜！" class="chayagi buruburu01">
				</div>
			</div>
			<div class="cv-btn border03">
				<a href="/quickmail/basic" class="pc" target="_blank"><img
						src="/static/renew_img/quickmail/cv-btn01.png" alt="ヤギにおまかせメェ〜"
						class="second-cv fuwafuwa01"></a>
				<a href="/quickmail/basic" class="sp" target="_blank"><img
						src="/static/renew_img/quickmail/cv-btn01-sp.png" alt="ヤギにおまかせメェ〜"
						class="second-cv fuwafuwa01"></a>
			</div>
		</section>

		<!--使い方-->
		<section class="third">
			<div class="wrapper">
				<h2 class="pc"><img src="/static/renew_img/quickmail/third-h2.png" alt="ラクラク！ヤギの宅配便は入力だけお願いメェ〜"></h2>
				<h2 class="sp"><img src="/static/renew_img/quickmail/third-h2-sp.png" alt="ラクラク！ヤギの宅配便は入力だけお願いメェ〜"></h2>
				<ul class="step pc">
					<li>
						<div class="step-item"><img src="/static/renew_img/quickmail/step01.png" alt="①スマホやPCで簡単入力">
							<p class="step-ti">①スマホやPCで簡単入力</p>
							<p>※送付状、履歴書は必須</p>
						</div>
					</li>
					<li>
						<div class="step-item"><img src="/static/renew_img/quickmail/step02.png" alt="②購入完了">
							<p class="step-ti">②購入完了</p>
						</div>
					</li>
					<li>
						<div class="step-item"><img src="/static/renew_img/quickmail/step03.png" alt="③ヤギの宅配便で郵送">
							<p class="step-ti">③ヤギの宅配便で郵送</p>
							<p>※投函まで1-2日ほど</p>
						</div>
					</li>
				</ul>
				<ul class="step-sp sp">
					<li>
						<div class="step-item"><img src="/static/renew_img/quickmail/step01-sp.png" alt="①スマホやPCで簡単入力">
							<p class="step-ti">①スマホやPCで簡単入力</p>
							<p>※送付状、履歴書は必須</p>
						</div>
					</li>
					<li>
						<div class="step-item"><img src="/static/renew_img/quickmail/step02-sp.png" alt="②購入完了">
							<p class="step-ti">②購入完了</p>
							<!--<p>※クレジットカード決済のみ</p>-->
						</div>
					</li>
					<li>
						<div class="step-item"><img src="/static/renew_img/quickmail/step03.png" alt="③ヤギの宅配便で郵送">
							<p class="step-ti">③ヤギの宅配便で郵送</p>
							<p>※投函まで1-2日ほど</p>
						</div>
					</li>
				</ul>
				<div class="amazon_quickmail">
					<!-- <h3>＼Amazonでの出品はじめました！／<br>ー</h3>
				<p style="
					text-align: center;
					margin-bottom: 20px;
				">今まではクレジットカードのみの支払いでしたが、<br class="pc">
										この度<span class="amazon_lead_span">Amazonでも購入できる</span>ようアップデートいたしました。
										<br data-v-db4b1aae=""><br data-v-db4b1aae="">
										このアップデートにより、<br class="pc">
										以前よりご希望の多かったコンビニ払いが選択できるようになります！</p> -->
					<div class="amazon_quickmail_lead">
						<img src="/static/renew2_img/yagitaku04.png" alt="Amazon出品">
						<img src="/static/renew2_img/yagitaku_postimage.png" alt="Amazon出品">
					</div>
					<p class="amazon_quickmail_how">
						<!-- Amazonにて購入後、コードが発行されます。履歴書サイトで履歴書や職務経歴書、送付状を入力後、【ヤギの宅配便】の必要項目を入力し、Amazonで発行したコードを入力すると決済が完了します。<br> -->
						<br>※確実に投函したことを残すため、投函時には写真を残しています。もし、ご希望がありましたら、投函時の写真もお渡しすることが可能ですので、ご安心ください。
					</p>
					<div>

						<img v-if="false" src="/static/renew2_img/yagitaku880_20240227.png" alt="期間限定800円に値下げ" style="
						display: block;
						margin: 0 auto 10px;
					" class="yagi800">
						<a href="https://amzn.to/3weli5Y" v-if="false" target="_blank"
							class="amazon_quickmail_btn">Amazonでヤギの宅配便を購入する</a>
						<p v-if="false" style="
					text-align: center;
					color: #E3165C;
					">3月8日までキャンペーン実施</p>
					</div>
				</div>
				<ul class="pc" style="
				display: flex;
				justify-content: space-between;
				margin-top: 50px;
				padding-bottom: 100px;
				align-items: flex-end;
			">
					<li style="width: calc(100% / 3 - 10px);">
						<img src="/static/renew2_img/yagitaku_review01.png" alt="レビュー①" style="width: 100%;">
					</li>
					<li style="width: calc(100% / 3 - 10px);">
						<img src="/static/renew2_img/yagitaku_review02.png" alt="レビュー②" style="width: 100%;">
					</li>
					<li style="width: calc(100% / 3 - 10px);">
						<img src="/static/renew2_img/yagitaku_review03.png" alt="レビュー③" style="width: 100%;
			">
					</li>
				</ul>

				<ul class="sp" style="
				margin-top: 50px;
				padding-bottom: 100px;
			">
					<li style="margin-bottom: 10px;">
						<img src="/static/renew2_img/yagitaku_review01.png" alt="レビュー①" style="width: 100%;">
					</li>
					<li style="margin-bottom: 10px;">
						<img src="/static/renew2_img/yagitaku_review02.png" alt="レビュー②" style="width: 100%;">
					</li>
					<li>
						<img src="/static/renew2_img/yagitaku_review03.png" alt="レビュー③" style="width: 100%;
			">
					</li>
				</ul>
			</div>
		</section>
		<section class="third" v-if="false">
			<div class="wrapper">
				<h2 class="pc"><img src="/static/renew_img/quickmail/third-h2.png" alt="ラクラク！ヤギの宅配便は入力だけお願いメェ〜"></h2>
				<h2 class="sp"><img src="/static/renew_img/quickmail/third-h2-sp.png" alt="ラクラク！ヤギの宅配便は入力だけお願いメェ〜"></h2>
				<ul class="step pc">
					<li>
						<div class="step-item">
							<img src="/static/renew_img/quickmail/step01.png" alt="①スマホやPCで簡単入力">
							<p class="step-ti">①スマホやPCで簡単入力</p>
							<p>※送付状、履歴書は必須</p>
						</div>
					</li>
					<li>
						<div class="step-item">
							<img src="/static/renew_img/quickmail/step02.png" alt="②購入完了">
							<p class="step-ti">②購入完了</p>
							<p v-if="$site.appFlag != 'b'">※クレジットカード決済のみ</p>
						</div>
					</li>
					<li>
						<div class="step-item">
							<img src="/static/renew_img/quickmail/step03.png" alt="③ヤギの宅配便で郵送">
							<p class="step-ti">③ヤギの宅配便で郵送</p>
							<p>※投函まで1-2日ほど</p>
						</div>
					</li>
				</ul>
				<ul class="step-sp sp">
					<li>
						<div class="step-item">
							<img src="/static/renew_img/quickmail/step01-sp.png" alt="①スマホやPCで簡単入力">
							<p class="step-ti">①スマホやPCで簡単入力</p>
							<p>※送付状、履歴書は必須</p>
						</div>
					</li>
					<li>
						<div class="step-item">
							<img src="/static/renew_img/quickmail/step02-sp.png" alt="②購入完了">
							<p class="step-ti">②購入完了</p>
							<p v-if="$site.appFlag != 'b'">※クレジットカード決済のみ</p>
						</div>
					</li>
					<li>
						<div class="step-item">
							<img src="/static/renew_img/quickmail/step03.png" alt="③ヤギの宅配便で郵送">
							<p class="step-ti">③ヤギの宅配便で郵送</p>
							<p>※投函まで1-2日ほど</p>
						</div>
					</li>
				</ul>
			</div>
		</section>

		<section class="fourth">
			<div class="wrapper">
				<h3 class="fourth-h3 pc"><img src="/static/renew_img/quickmail/cv-txt.png"
						alt="印刷から投函までおまかせ！面倒な作業はしなくていい！"></h3>
				<h3 class="fourth-h3 sp"><img src="/static/renew_img/quickmail/cv-txt-sp.png"
						alt="印刷から投函までおまかせ！面倒な作業はしなくていい！"></h3>
				<div class="hero-txt fourth-hero-txt">
					<img src="/static/renew_img/quickmail/yagitaku-txt-nomal.png" alt="ヤギの宅配便" class="txt-nomal-sp">
					<img src="/static/renew_img/quickmail/nedan_20230630.png" alt="1,100円（税込）" class="fourth-nedan pc">
					<img src="/static/renew_img/quickmail/nedan_20230630.png" alt="1,100円（税込）"
						class="sp sp-nedan sp-hero-txt">
				</div>
				<div class="hero-txt">
					<img src="/static/renew_img/quickmail/deco03.png" alt="ラディッシュ" class="deco03">
					<a href="/quickmail/basic" target="_blank" class="cv-link"><img
							src="/static/renew_img/quickmail/cv-btn02.png" alt="ヤギにおまかせメェ〜" class="cv-btn pyon01"></a>
					<img src="/static/renew_img/quickmail/deco03.png" alt="ラディッシュ" class="deco03">
				</div>
			</div>
		</section>

		<section class="fqa wrapper">
			<h3 class="fqa-ti">よくあるご質問</h3>
			<ul class="fqa-container">
				<li class="fqa-list">
					<h4 class="question">履歴書は手書きではなくても大丈夫ですか。</h4>
					<img src="/static/renew2_img/yagitaku_007_graph_01.png" alt="出典：転職サービス「doda」"
						style="width: 100%; margin-bottom: 15px;">
					<p class="answer">
						転職サービス「doda」の調査によると、手書きにこだわる企業は減っているようです。安心して、面倒な作業はヤギ宅にお任せください！<br>出典：転職サービス「doda」</p>
				</li>
				<li class="fqa-list">
					<h4 class="question">フォーマットのサイズを指定することはできますか。</h4>
					<p class="answer">できません。用紙サイズは、A4サイズとなります。</p>
				</li>
				<li class="fqa-list">
					<h4 class="question">Yagish以外で作成した書類を同封できますか。</h4>
					<p class="answer">できません。Yagishで作成されたテンプレートのみ対応できます。</p>
				</li>
				<li class="fqa-list">
					<h4 class="question">用紙・封筒の品質について教えてください。</h4>
					<p class="answer">
						履歴書の提出のマナーに相応しい上質紙や白い封筒の使用など品質は問題ございません。また、送り先の企業が確認しやすいように「履歴書在中」のスタンプを押して送付いたします。</p>
				</li>
				<li class="fqa-list">
					<h4 class="question">個人情報はどのように管理されていますか。</h4>
					<p class="answer">個人情報の管理は、システム化され最大限情報漏洩対策をしています。人間による持ち出しの防止策としてダブルチェック管理体制を導入しております。</p>
				</li>
				<li class="fqa-list">
					<h4 class="question">いつごろ配達されますか。</h4>
					<p class="answer">
						送り先の企業の地域により配送期間が異なります。営業日を基準に1〜2日以内の発送になりますので、お急ぎの場合はPDFをダウンロードしたりコンビニプリントをするなどご自身でのご対応をお勧めいたします。
					</p>
				</li>
				<li class="fqa-list">
					<h4 class="question">配達されたか確認できますか。</h4>
					<p class="answer">郵便の発送状況は確認できませんが、郵便ポストに投函後、システムから発送済みのメールが自動的に送られますので、ご確認ください。</p>
				</li>
				<li class="fqa-list">
					<h4 class="question">書留や速達での郵送は可能ですか。</h4>
					<p class="answer">できません。お急ぎの場合や配達の記録を確認されたい場合はご自身でご手配ください。</p>
				</li>
				<li class="fqa-list">
					<h4 class="question">注文後キャンセルできますか。</h4>
					<p class="answer">できません。注文して決済まで終わった場合は、原則的にキャンセルできません。</p>
				</li>
			</ul>
		</section>

		<section class="fifth">
			<div class="wrapper">
				<div class="print">
					<img src="/static/renew_img/quickmail/print01.png" alt="コンビニプリント" class="print-sp">
					<div class="print-txt">
						<p class="print-ti">面接に履歴書を持っていく<span>ときは、<br>
							</span>コンビニプリント<span>を使うメェ〜</span></p>
						<!--<img src="/static/renew_img/quickmail/print02.png" alt="面接に履歴書を持っていくときは、コンビニプリントを使うメェ〜">-->
						<a href="/" target="_blank" class="link link-deco">コンビニプリントを使う</a>
					</div>
				</div>
			</div>
		</section>

		<section class="sixth">
			<div class="wrapper">
				<div class="hero-txt">
					<img src="/static/renew_img/quickmail/deco03.png" alt="ラディッシュ" class="deco03 deco04">
					<a href="/quickmail/basic" target="_blank" class="cv-link"><img
							src="/static/renew_img/quickmail/cv-btn03.png" alt="ヤギにおまかせメェ〜" class="cv-btn pyon01"></a>
					<img src="/static/renew_img/quickmail/deco03.png" alt="ラディッシュ" class="deco03">
				</div>
			</div>
		</section>

		<div style="text-align: center; padding: 20px;">
			<a href="/quickmailterms" target="_blank">利用規約は<span style="color: #E3165C;">こちら</span></a>
		</div>

	</div>
</template>
<style lang="css" src="@/assets/css/quickmail_stylesheet.css"></style>
<style lang="css" src="@/assets/css/quickmail_animation.css"></style>
<style lang="css" src="@/assets/css/quickmail_reset.css"></style>

<style lang="scss" scoped>
body {
	background: #EFF8F8;
}

.hero-img {
	padding: 0;
}

.hero-img_LP {
	//   margin: 0 calc(50% - 50vw);
	width: 100vw;
	padding: 20px 50px;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}

@media screen and (max-width:480px) {
	.hero-img_LP {
		padding: 20px;
	}
}
</style>
<style lang="scss" scoped>
.amazon_quickmail {
	margin-top: 50px;
}

.amazon_quickmail h3 {
	font-size: 1.2rem;
	color: #004d40;
	text-align: center;
}

.amazon_quickmail_lead {
	display: flex;
	justify-content: center;
}

.amazon_quickmail_lead img {
	margin-right: 20px;
}

.amazon_lead_span {
	color: #E3165C;
}

.amazon_quickmail_how {
	background: #fff;
	padding: 20px;
	border-radius: 10px;
	margin: 20px;
}

a.amazon_quickmail_btn {
	display: flex;
	justify-content: center;
	background: #E3165C;
	color: #fff;
	padding: 15px;
	border-radius: 50px;
	font-size: 1rem;
	font-weight: bold;
	letter-spacing: 1.2px;
	width: 50%;
	margin: 0 auto;
}

a.amazon_quickmail_btn:hover {
	text-decoration: none;
}

@media screen and (max-width: 480px) {

	a.amazon_quickmail_btn {
		width: 100%;
	}
}
</style>
<script>
export default {
	data: function () {
		return {
			question1: false,
			question2: false,
			question3: false,
			question4: false,
			question5: false,
			question6: false,
			question7: false,
			question8: false
		}
	},
	computed: {},
	methods: {
		viewAnswer: function (name) {
			console.error(name)
			this.question1 = true
		}
	},
	watch: {},
	mounted: function () { }
}
</script>